module.exports = __webpack_public_path__ + "static/media/sauron.d92cdf5b.png";